export enum ExpandFaces {
	Default = 'default',
	FromStart = 'start',
	ByWidth = 'width',
	ByPercent = 'percent'
}